import request from "@/utils/request";
import {baseURL} from "@/utils/getawayModule";

/***
 *
 * 获取文章管理列表 get
 * @param query 分页参数
 * @return request
 * */
export function getArticleList(query) {
    return request({
        url: `${baseURL.businessApi}/articles`,
        method: 'get',
        params: query
    })
}

/**
 * 分页查询文章管理
 * @param query
 * @returns {AxiosPromise}
 */
export function articleList(query) {
    return request({
        url: `${baseURL.businessApi}/articles/list`,
        method: 'get',
        params: query
    })
}

/**
 * 增加文章管理 post
 * @param data 增加的数据
 * @return request
 * */
export function addArticle(data) {
    return request({
        url: `${baseURL.businessApi}/articles`,
        method: 'post',
        data: data
    })
}

/**
 * 删除文章管理  delete
 * @param id 文章管理id
 * @return request
 * */
export function deleteArticle(id) {
    return request({
        url: `${baseURL.businessApi}/articles/${id}`,
        method: 'delete'
    })
}

/***
 * 修改文章管理 Post
 * @param id 要修改的文章管理id
 * @param data 修改的数据
 * @return request
 *
 * */
export function updateArticle(data) {
    return request({
        url: `${baseURL.businessApi}/articles`,
        method: 'post',
        data: data
    })
}

/**
 * 查询文章列表管理接口
 * @param query
 * @returns {AxiosPromise}
 */
export function getArticlesTitle(query) {
    return request({
        url: `${baseURL.businessApi}/articles/title/list`,
        method: 'get',
        params: query
    })
}

/**
 * 根据id查询文章管理接口
 * */
export function getArticlesById(id) {
    return request({
        url: `${baseURL.businessApi}/articles/${id}`,
        method: 'get'
    })
}